import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';

import { Row, Col } from 'antd';

import { Switch, Route, withRouter } from 'react-router';
import { connect } from '../../../../../../../StateProvider';
import NavRoute from '../../../../../../../common/router/Route';
import NavRedirect from '../../../../../../../common/router/Redirect';
import routes from '../../../../../../../../routes';
import SCENE_CONTAINER from '../../../../../../../../configs/sceneContainer';

import ButtonClose from '../../../../../../../common/UI/ButtonClose';
import TabsMenu from '../../../../../../../common/UI/TabsMenu';
import Icon from '../../../../../../../common/UI/Icon';

import Actions from '../../Actions';
import ViewSelector from './ViewSelector';
import RecordsRefresh from '../../../../../../../Records/RecordsRefresh';
import RecordsActivities from '../../../../../../../Records/RecordsActivities';
import ManualActions from '../../../../../../../Manual/ManualActions';
import ViewSettings from './ViewSettings';

import { checkAccessOnObject } from '../../../../../../../../utils/rights';
import { getRecordsCountKey } from '../../../../../../../../utils/getRecordsKey';
import { getViewModeFromPath } from '../../../../../../../../utils/viewSettings';
import PRIVILEGE_CODES from '../../../../../../../../configs/privilegeCodes';
import RESOURCE_TYPES from '../../../../../../../../configs/resourceTypes';
import DEFAULTS from '../../../../../../../../configs/records';

import styles from './viewHeader.less';
import { VIEW_MODES } from '../../../../../../../../configs/viewSettings';

class ViewHeader extends Component {
  static propTypes = {
    catalog: PropTypes.object,
    viewId: PropTypes.string,
    isWebForm: PropTypes.bool,
    viewMode: PropTypes.string,
  };

  constructor() {
    super();
    this.state = {
      recordsCount: null,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { scene, viewMode } = this.props;
    const { scene: prevScene, viewMode: prevViewMode } = prevProps;

    if (scene !== prevScene || viewMode !== prevViewMode) {
      this.updateRecordsCount();
    }
  }

  getDefaultRoute(tabs) {
    // get from scene data (webform case)
    const viewMode = this.props.scene.getIn(['data', 'viewMode']) || this.props.viewMode;
    const defaultTab = tabs.find((t) => t.get('id') === viewMode) || tabs.getIn([0]);
    return defaultTab.get('route');
  }

  setDefaultRoute(tab) {}

  onClose = () => {
    this.props.onClose && this.props.onClose(this.props.sceneId);
  };

  updateRecordsCount = () => {
    const { scene, viewMode } = this.props;
    if (!scene) return undefined;
    const raw = viewMode || 'table';
    const mode = raw === 'records' ? 'table' : raw;
    const recordsCount = scene.get(getRecordsCountKey(mode));

    // update only whne not loading, to show previous value
    if (!scene.get('loading') && recordsCount !== undefined) {
      this.setState({ recordsCount });
    }
  };

  checkDateFieldsInCatalog = () => {
    const { catalog } = this.props;
    const fields = catalog && catalog.get('fields');
    return fields && fields.some((field) => field.get('type') === 'date');
  };

  checkManualInCatalog = () => {
    const { catalog, isWebForm } = this.props;

    // do not show in webforms
    if (isWebForm) return false;

    // show if manual is available
    const manual = catalog && catalog.get('manual');
    if (manual) return true;

    // show to edit manual
    const isAccess = checkAccessOnObject(RESOURCE_TYPES.CATALOG, catalog, PRIVILEGE_CODES.ACCESS);
    if (isAccess) return true;
  };

  getTabsItems = () => {
    const { t } = this.props;

    let tabs = Immutable.List([
      Immutable.Map({
        id: VIEW_MODES.TABLE,
        // icon: <TableOutlined />,
        color: '#429fc3',
        title: t('catalogData.types.table'),
        nameActive: t('catalogData.types.table'),
        route: routes.records,
      }),
      Immutable.Map({
        id: VIEW_MODES.CARDS,
        // icon: <AppstoreOutlined />,
        color: '#429fc3',
        title: t('catalogData.types.cards'),
        nameActive: t('catalogData.types.cards'),
        route: routes.cards,
      }),
    ]);

    if (this.checkDateFieldsInCatalog()) {
      tabs = tabs.concat(
        Immutable.List([
          Immutable.Map({
            id: VIEW_MODES.CALENDAR,
            // icon: <CalendarOutlined style={{ verticalAlign: '-2px' }} />,
            color: '#28bb5d',
            title: t('catalogData.types.calendar'),
            nameActive: t('catalogData.types.calendar'),
            route: routes.calendar,
          }),
          Immutable.Map({
            id: VIEW_MODES.GANTT,
            // icon: <CalendarOutlined style={{ verticalAlign: '-2px' }} />,
            color: '#28bb5d',
            title: t('catalogData.types.gantt'),
            nameActive: t('catalogData.types.gantt'),
            route: routes.gantt,
          }),
        ]),
      );
    }

    tabs = tabs.concat(
      Immutable.List([
        Immutable.Map({
          id: VIEW_MODES.REPORTS,
          // icon: <FundOutlined />,
          color: '#c79e26',
          title: t('catalogData.types.reports'),
          nameActive: t('catalogData.types.reports'),
          route: routes.reports,
        }),

        Immutable.Map({
          id: VIEW_MODES.PIVOT,
          // icon: <LayoutOutlined />,
          color: '#c79e26',
          title: t('catalogData.types.pivotTables'),
          nameActive: t('catalogData.types.pivotTables'),
          route: routes.pivot,
        }),

        Immutable.Map({
          id: VIEW_MODES.COUNT,
          // icon: (
          //   <span
          //     style={{
          //       position: 'relative',
          //       top: '-2px',
          //     }}
          //   >
          //     Σ
          //   </span>
          // ),
          color: '#c79e26',
          title: t('catalogData.types.statistics'),
          nameActive: t('catalogData.types.statistics'),
          route: routes.count,
        }),

        Immutable.Map({
          id: VIEW_MODES.HISTORY,
          // icon: <HistoryOutlined />,
          color: '#c27fcd',
          title: t('catalogData.types.history'),
          nameActive: t('catalogData.types.history'),
          route: routes.history,
        }),
      ]),
    );

    if (this.checkManualInCatalog()) {
      tabs = tabs.concat(
        Immutable.List([
          Immutable.Map({
            id: VIEW_MODES.MANUAL,
            // icon: <InfoCircleOutlined />,
            color: '#9ea1a7',
            title: t('catalogData.types.manual'),
            nameActive: t('catalogData.types.manual'),
            route: routes.manual,
          }),
        ]),
      );
    }

    return tabs;
  };

  render() {
    const {
      sceneId,
      scene,
      catalogId,
      catalog,
      viewId,
      viewMode,
      userViewMode,
      openRecordsInModal,
      isWebForm,
      leftPanel,
      selectedRowsIds,
      allRowsSelected,
      onResetSelection,
      t,
    } = this.props;

    const fields = catalog && catalog.get('fields');
    const tabs = this.getTabsItems();

    // count records
    const recordsCount = this.state.recordsCount;
    const recordsCountText = !isNaN(recordsCount) ? t('record.groupRecords.count', { count: recordsCount }) : '';

    const inPopup = scene.get('container') === SCENE_CONTAINER.POPUP;
    const withPanel = inPopup ? false : leftPanel;
    const showTabs = !(isWebForm && scene.getIn(['data', 'viewMode']) && !inPopup); // not allow to sleect view mode in webform with strict viewMode. Allow only in popup

    return (
      <div className={styles.container}>
        <Row type="flex" justify="space-between" align="middle" className={styles.containerHeader}>
          {/* редирект на режим отображения */}
          <NavRoute
            route={routes.view}
            exact
            render={(props) => {
              const viewsLoaded = catalog && catalog.get('viewsLoaded');
              if (!viewsLoaded) return null;
              return (
                /* добавил viewId в качестве параметра */
                /* добавил viewMode в качестве параметра */
                <NavRedirect
                  route={this.getDefaultRoute(tabs, {
                    viewId: this.props.viewId,
                    viewMode: this.props.viewMode,
                  })}
                />
              );
            }}
          />

          {/* TITLE */}
          <Col>
            <Row align="middle">
              {!withPanel && catalog && (
                <h2 className={styles.catalogName}>
                  <Icon type={`icon ${catalog.get('icon')}`} className={styles.catalogIcon} />
                  {catalog.get('name')}
                </h2>
              )}
              {!withPanel && <span className={styles.splitterSlah}>/</span>}

              <ViewSelector
                sceneId={sceneId}
                catalogId={catalogId}
                viewMode={viewMode}
                userViewMode={userViewMode}
                catalog={catalog}
                viewId={viewId}
              />
              {!withPanel && <span className={styles.splitterSlah}>/</span>}

              <NavRoute
                route={routes.viewMode}
                render={(props) => {
                  const viewMode = props.match.params.viewMode;
                  const maxRecords = DEFAULTS.RECORDS_LIMIT[viewMode];
                  if (recordsCountText === '') return null;
                  if (maxRecords && recordsCount > maxRecords) {
                    return (
                      <span className={styles.recordsCount}>
                        {recordsCountText}
                        <span className={styles.recordsShown} title={t('views.shownRecordsDescription')}>
                          {t('views.shownRecords')} {maxRecords}
                        </span>
                      </span>
                    );
                  }
                  return <span className={styles.recordsCount}>{recordsCountText}</span>;
                }}
              />

              <RecordsRefresh
                scene={scene}
                catalog={catalog}
                viewId={viewId}
                viewMode={getViewModeFromPath(this.props.location.pathname)}
                isWebForm={isWebForm}
                openRecordsInModal={openRecordsInModal}
                createInPopup
              />
            </Row>
          </Col>

          {/* ACTIONS */}
          <Col>
            <Row className={styles.rightActionContainer}>
              {!leftPanel && (
                <Actions
                  modes={inPopup ? ['view'] : ['catalog', 'view']}
                  sceneId={sceneId}
                  catalog={catalog}
                  title={t('catalogData.actionsButton')}
                />
              )}

              {catalog && (
                <Switch>
                  <Route
                    path={routes.records.path}
                    render={(props) => (
                      <RecordsActivities
                        catalog={catalog}
                        sceneId={sceneId}
                        viewId={viewId}
                        viewMode={VIEW_MODES.TABLE}
                        selectedRowsIds={selectedRowsIds}
                        allRowsSelected={allRowsSelected}
                        onResetSelection={onResetSelection}
                        isWebForm={isWebForm}
                        openRecordsInModal={openRecordsInModal}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path={routes.cards.path}
                    render={(props) => (
                      <RecordsActivities
                        catalog={catalog}
                        sceneId={sceneId}
                        viewId={viewId}
                        viewMode={VIEW_MODES.CARDS}
                        isWebForm={isWebForm}
                        openRecordsInModal={openRecordsInModal}
                        createInPopup
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path={routes.calendar.path}
                    render={(props) => (
                      <RecordsActivities
                        catalog={catalog}
                        sceneId={sceneId}
                        viewId={viewId}
                        viewMode={VIEW_MODES.CALENDAR}
                        isWebForm={isWebForm}
                        openRecordsInModal={openRecordsInModal}
                        createInPopup
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path={routes.gantt.path}
                    render={(props) => (
                      <RecordsActivities
                        catalog={catalog}
                        sceneId={sceneId}
                        viewId={viewId}
                        viewMode={VIEW_MODES.TABLE}
                        selectedRowsIds={selectedRowsIds}
                        onResetSelection={onResetSelection}
                        recordsCount={scene && scene.get(getRecordsCountKey(VIEW_MODES.GANTT))}
                        isWebForm={isWebForm}
                        openRecordsInModal={openRecordsInModal}
                        createInPopup
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path={routes.reports.path}
                    render={(props) => (
                      <RecordsActivities
                        catalog={catalog}
                        sceneId={sceneId}
                        viewId={viewId}
                        viewMode={VIEW_MODES.REPORTS}
                        isWebForm={isWebForm}
                        openRecordsInModal={openRecordsInModal}
                        createInPopup
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path={routes.pivot.path}
                    render={(props) => (
                      <RecordsActivities
                        catalog={catalog}
                        sceneId={sceneId}
                        viewId={viewId}
                        viewMode={VIEW_MODES.PIVOT}
                        isWebForm={isWebForm}
                        openRecordsInModal={openRecordsInModal}
                        createInPopup
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path={routes.count.path}
                    render={(props) => (
                      <RecordsActivities
                        catalog={catalog}
                        sceneId={sceneId}
                        viewId={viewId}
                        viewMode={VIEW_MODES.COUNT}
                        isWebForm={isWebForm}
                        openRecordsInModal={openRecordsInModal}
                        createInPopup
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path={routes.manual.path}
                    render={(props) => <ManualActions catalog={catalog} sceneId={sceneId} viewId={viewId} {...props} />}
                  />
                </Switch>
              )}
              {inPopup && <ButtonClose onClick={this.onClose} shiftRight />}
            </Row>
          </Col>
        </Row>
        <Row type="flex" align="middle" wrap={false} className={styles.containerFilter}>
          {/* TABS (view mode) */}
          {showTabs && (
            <NavRoute route={routes.record}>
              {(props) =>
                !props.match && (
                  <Col className={styles.tabsMenu}>
                    <TabsMenu items={tabs} onClick={_.bind(this.setDefaultRoute, this)} />
                  </Col>
                )
              }
            </NavRoute>
          )}
          <NavRoute
            route={routes.viewMode}
            render={(props) => (
              <ViewSettings
                sceneId={sceneId}
                scene={scene}
                catalogId={catalogId}
                catalog={catalog}
                viewId={viewId}
                viewSettings={this.props.viewSettings}
                viewMode={props.match?.params?.viewMode || this.props.viewMode}
                fields={fields}
                className={styles.viewSettings}
                hideControls={!!leftPanel}
              />
            )}
          />
        </Row>
      </div>
    );
  }
}

export default withTranslation()(
  connect(
    withRouter(ViewHeader),
    {
      catalogsHistory: ['catalogsHistory'],
      scenes: ['scenes'],
      viewSettings: ['viewSettings', 'catalogs'],
    },
    (props, { catalogsHistory, scenes, viewSettings }) => {
      const scene = scenes.get(props.sceneId);
      const filter = catalogsHistory.getIn([props.catalogId, 'filter']);

      const catalogViewSettings = viewSettings && viewSettings.getIn([props.catalogId, 'views', props.viewId]);

      return {
        scene,
        filter,
        viewSettings: catalogViewSettings,
        ...props,
      };
    },
  ),
);
